<template>
    <div>
        <deal-option />
        <searchMatch />
        <postDeals />
        <update-deal></update-deal>
    </div>
</template>

<script>
    import searchMatch from "@/components/Modals/dealsSystem/searchMatch";
    import postDeals from "@/components/Modals/dealsSystem/postDeals";
    import UpdateDeal from "./updateDeal";
    import dealOption from "./dealOption";

    export default {
        name: "dealbox.vue",
        components: {
            UpdateDeal,
            searchMatch,
            postDeals,
            dealOption
        },
        mounted() {
            // $("#deals-my-poll-popup").modal("show");
        },
    }
</script>

<style scoped>

</style>
